import React, { FunctionComponent } from "react";
import { Box } from "theme-ui"

interface MarginProps {
  margins: {
    desktop: {
      bottom: string;
      top: string;
    }
    mobile: {
      bottom: string;
      top: string;
    }
    tablet: {
      bottom: string;
      top: string;
    }
  }
}

const Margin: FunctionComponent<MarginProps> = ({ margins, children }) =>
  <Box
    className="custom-margin-section"
    sx={{
      '@media only screen and (max-width: 767px)': {
        mb: margins.mobile.bottom ? `${margins?.mobile?.bottom}px` : '0',
        mt: margins.mobile.top ? `${margins?.mobile?.top}px` : '0'
      },
      '@media only screen and (min-width: 768px) and (max-width: 1023px)': {
        mb: margins.tablet.bottom ? `${margins?.tablet?.bottom}px` : '0',
        mt: margins.tablet.top ? `${margins?.tablet?.top}px` : '0'
      },
      '@media only screen and (min-width: 1024px)': {
        mb: margins.desktop.bottom ? `${margins?.desktop?.bottom}px` : '0',
        mt: margins.desktop.top ? `${margins?.desktop?.top}px` : '0'
      },
    }}
  >{children}</Box>


export default Margin;
